import formatName from 'I18n/utils/formatName';
const removeNonBasicLatin = text => text.replace(/[^ -]/g, '');
const slugify = (text = '') => (text.toString().normalize ? text.toString().normalize('NFD') : removeNonBasicLatin(text.toString())).replace(/[̀-ͯ]/g, '').toLowerCase().trim().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-');
export const getAchievementUrlSlug = ({
  firstName,
  lastName,
  trackName
}) => {
  const userSlug = slugify(formatName({
    firstName,
    lastName
  })) || 'user';
  const trackSlug = slugify(trackName) || 'achievement';
  return `${userSlug}/${trackSlug}`;
};